const initialState = () => {
    return {
        id: null,
        login: null,
        roles: [],
        discount_percent: 0,
        is_delayed_payment_allowed: false,
        is_company: null,

        firstName: null,
        lastName: null,
        email: null,
        corporateName: null,
        addressStreet: null,
        addressBuildingNumber: null,
        addressApartmentNumber: null,
        addressPostal: null,
        addressCity: null,
        addressCountry: 'POLAND',
        nip: null,
        phoneNumber: null,
    };
};

const state = initialState;

const getters = {
    getId: (state) => {
        return state.id;
    },

    getName: (state) => {
        return state.login;
    },

    getRole: (state) => {
        return state.roles.length?state.roles[0]:null;
    },

    isLoggedIn: (state) => {
        return state.id !== null;
    },

    isSuperAdmin: (state) => {
        return window.APP.manage_user.isSuperAdmin;
    },

    isAdmin: (state) => {
        return window.APP.manage_user.isAdmin;
    },

    isCompany: (state) => {
        return state.is_company === true;
    },

    getDiscountPercent: (state) => {
        return state.discount_percent;
    },

    isDelayedPaymentAllowed: (state) => {
        return state.is_delayed_payment_allowed;
    },

    getEmail: (state) => {
        return state.email;
    },

    getPhone: (state) => {
        return state.phoneNumber;
    },

    getCompanyName: (state) => {
        return state.corporateName;
    },

    getAddress: (state) => {
        return state.addressStreet;
    },

    getTaxNumber: (state) => {
        return state.nip;
    },

    getPostCode: (state) => {
        return state.addressPostal;
    },

    getCountry: (state) => {
        return state.addressCountry;
    },

    getCity: (state) => {
        return state.addressCity;
    },
};

const mutations = {
    setUser(state, user) {
        state.id = user.id;
        state.login = user.login;
        state.roles = user.roles;
        state.email = user.email;
        state.phoneNumber = user.phoneNumber;
        state.firstName = user.firstName;
        state.lastName = user.lastName;
        state.is_company = !!user.nip;
        state.corporateName = user.corporateName;
        state.addressStreet = user.addressStreet;
        state.nip = user.nip;
        state.addressPostal = user.addressPostal;
        state.addressCountry = user.addressCountry;
        state.addressCity = user.addressCity;
        state.addressBuildingNumber = user.addressBuildingNumber;
        state.addressApartmentNumber = user.addressApartmentNumber;
    },
};

const actions = {
    setUser({commit}, data) {
        commit('setUser', data);
    },
    unsetUser({commit}) {
        commit('setUser', initialState());
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
